var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages"},[_c('div',{staticClass:"patew"},[_c('div',{staticClass:"title"},[_vm._v("\n            关于园测信息科技股份有限公司拟首次公开发行股票接受辅导的公告\n        ")]),_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,ref:"pdf",refInFor:true,attrs:{"src":_vm.pdfUrl,"page":i}})})],2),_c('div',[_c('CopyRight')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }